import { 
    getPasswordForShowLink,
    getDisclaimerContent,
    getDisclaimers, 
    getAccessCodes
} from '@/service/api';
import {
    FETCH_FAILURE,
    FETCH_UPDATE,
    FETCH_PASSWORD_DETAILS_SUCCESS,
    FETCH_PASSWORD_DETAILS_FAILURE,  
    FETCH_DISCLAIMERS_SUCCESS,
    FETCH_DISCLAIMERS_FAILURE,
    FETCH_DISCLAIMER_CONTENT_SUCCESS,
    FETCH_DISCLAIMER_CONTENT_FAILURE,
    REMOVE_FIRST_DISCLAIMER,
    FETCH_CONFERENCE_ACCESS_CODES_SUCCESS,
    FETCH_CONFERENCE_ACCESS_CODES_FAILURE,
    CREATE_USER_SESSION_SUCCESS
} from '@/store/actions';

import { commitLocalAndToGlobalService, globalCommit } from '@/utils/vuex';
import Constants from '@/utils/constants';

export const PresentationModule = {
    namespaced: true,
    state: {
        passwordDetails: {},
        presentation: {},
        disclaimerContent: {},
        disclaimersData: {},
        conference: {},
        accessCodes: {
            pin:'',
            eventIds: {}
        },
        logId: ''
    },
    mutations: {
        [FETCH_PASSWORD_DETAILS_SUCCESS]: (state, passwordDetails) => {
            state.passwordDetails = passwordDetails;
        },
        [FETCH_CONFERENCE_ACCESS_CODES_SUCCESS]: (state, accessCodes) => {
            state.accessCodes = accessCodes.data;
        },
        [FETCH_DISCLAIMERS_SUCCESS]: (state, disclaimersData) => {
            state.disclaimersData = disclaimersData;
        },
        [FETCH_DISCLAIMER_CONTENT_SUCCESS]: (state, disclaimerContent) => {
            state.disclaimerContent = disclaimerContent;
        },
        [REMOVE_FIRST_DISCLAIMER]: (state) => {
            state.disclaimersData.shift();
        },
        [CREATE_USER_SESSION_SUCCESS]: (state, logId) => {
            state.logId = logId; 
        }
    },
    actions: {
        async fetchAccessCodes({ commit }, params) {
            globalCommit('service', commit, FETCH_UPDATE);
            try {
                const accessCodes = await getAccessCodes(params.presId, params.confId, params.replay);
                commitLocalAndToGlobalService(commit, FETCH_CONFERENCE_ACCESS_CODES_SUCCESS, accessCodes);
            } catch (error) {
                globalCommit(commit, FETCH_CONFERENCE_ACCESS_CODES_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
            }
        },

        async fetchPasswordDetails({ commit }, showLink) {
            globalCommit('service', commit, FETCH_UPDATE);
            try {
                const passwordDetails = await getPasswordForShowLink(showLink);
                commitLocalAndToGlobalService(commit, FETCH_PASSWORD_DETAILS_SUCCESS, passwordDetails.data);
            } catch (error) {
                commitLocalAndToGlobalService(commit, FETCH_PASSWORD_DETAILS_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
            }
        },
        async commitLogId({ commit }, logId) {
            commitLocalAndToGlobalService(commit, CREATE_USER_SESSION_SUCCESS, logId);
        },
        async fetchDisclaimers({ commit, rootGetters }) {
            const { PresId } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
            globalCommit('service', commit, FETCH_UPDATE);
            try {
                const disclaimers = await getDisclaimers(PresId);
                commitLocalAndToGlobalService(commit, FETCH_DISCLAIMERS_SUCCESS, disclaimers.data);
            } catch (error) {
                commitLocalAndToGlobalService(commit, FETCH_DISCLAIMERS_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
            }
        },
        async fetchDisclaimerContent({ commit, state, rootGetters }) {
            const { PresId } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
            const disclaimers = rootGetters['presentation/GET_DISCLAIMERS'];

            globalCommit('service', commit, FETCH_UPDATE);
            try {
                const disclaimerContent = await getDisclaimerContent(PresId, disclaimers[0].DisclaimerId);
                commitLocalAndToGlobalService(commit, FETCH_DISCLAIMER_CONTENT_SUCCESS, disclaimerContent.data);
            } catch (error) {
                commitLocalAndToGlobalService(commit, FETCH_DISCLAIMER_CONTENT_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
            }
        },
        async removeFirstDisclaimerFromStore({ commit }) {
                commitLocalAndToGlobalService(commit, REMOVE_FIRST_DISCLAIMER);
        },
    },
    getters: {
        GET_PASSWORD_DETAILS: state => state.passwordDetails,
        GET_CONFERENCE_CALL_DETAILS: state => state.conference,
        GET_DISCLAIMER_CONTENT: state => state.disclaimerContent,
        GET_ACCESS_CODES: state => state.accessCodes,
        GET_LOG_ID: state => state.logId,
        GET_DISCLAIMERS: state => state.disclaimersData
    }
}